import React, { FunctionComponent } from 'react'
import { Avatar, Heading, Loader, Text } from '@afterpaytouch/core'
import { useConsumerName, useConsumerSelector } from '../../state'
import { useTranslation } from '../../utils/convergence'
import { TrackOnMount } from '../../integrations/monitoring'
import { TrackingEvent } from '../../model/monitoring'
import { useCheckoutSizes } from '../../utils/responsive'
import { MaskedElement } from '@afterpaytouch/integrations/MaskedElement'
import { isUndefinedOrEmpty } from '@afterpay/utils'
import styles from './style.module.css'

interface WelcomeBackRecognitionProps {
  stepUpGivenNames?: string
}

export const WelcomeBackRecognition: FunctionComponent<WelcomeBackRecognitionProps> = ({ stepUpGivenNames }) => {
  const { t } = useTranslation()
  const storeConsumerName = useConsumerName()
  const { email, profile, stepUpIdentity } = useConsumerSelector()
  const consumerName = stepUpGivenNames ?? storeConsumerName
  const firstName = (stepUpGivenNames ?? profile?.givenNames)?.trim() || storeConsumerName.trim().split(/\s+/)[0]
  const { textSize, headingSize, smallTextSize } = useCheckoutSizes()

  return (
    <div className={styles.container} data-testid='auto-remember-me-welcome-back'>
      <TrackOnMount
        eventName={TrackingEvent.VIEWED_AUTO_REMEMBER_ME_PAGE}
        eventProperties={stepUpGivenNames === undefined ? undefined : { isEmailEmpty: true, isMobileEmpty: isUndefinedOrEmpty(stepUpIdentity?.maskedMobile) }}
      />
      <MaskedElement actionName='Auto Remember Me Welcome Back'>
        <div className={styles.avatar}>
          <Avatar size='M' src='' alt={consumerName} name={consumerName} title={consumerName} />
        </div>
        <Heading size={headingSize}>{t('common:rememberMeWelcomeBack', { name: firstName })}</Heading>
        {stepUpGivenNames === undefined && (email ?? '') !== '' && (
          <div className={styles.email}>
            <Text size={textSize}>{email}</Text>
          </div>
        )}
      </MaskedElement>
      <div className={styles.recognized}>
        <span className={styles.check} aria-hidden='true'>
          ✓
        </span>
        <Text size={smallTextSize}>{t('common:rememberMeRecognizedDevice')}</Text>
      </div>
      <Loader />
      <Text size={textSize}>{t('common:rememberMeLoggingInSecurely')}</Text>
    </div>
  )
}
